import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import MainKvStore from './store';
import Link from '@src/components/link';
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import cx from 'classnames';
import $$tracker from '@src/tracker';
import { handleDownloadLinkClick, RECHARGE_UNAVAILABLE_MESSAGE } from '@src/utils/download-link';

const styles = require('./index.less');

const MainKv = ({ store, onOpenHarmonyDownloadModal }) => {
  store.use();

  const appointment = React.useMemo(
    () => {
      return (
        <div className={styles.appointmentContent}>
          <Link
            className={cx(styles.btnAppointment, { [styles.btnAppointmentActive]: store.config.phone })}
            data-name="预约按钮"
            onClick={() => store.openAppointmentModal()}
          />
          <div className={styles.appointmentCount}>
            全网已有 <span>{store.formatNumber(store.subscribeTotal)}</span> 位少侠预约
          </div>
        </div>
      );
    },
    [store.config.phone, store.subscribeTotal]
  );

  const download = React.useMemo(
    () => {
      return (
        <div className={styles.publicBetaDownload}>
          <div className={styles.publicBetaQrcode} data-name="下载二维码">
            <div className={styles.qrcodeImg}>{store.downloadUrl.indexQrcode && <iframe src={store.downloadUrl.indexQrcode} title="首页扫码下载游戏" />}</div>
          </div>
          <div className={styles.platformColumn}>
            <Link
              className={cx(styles.publicBetaButton, styles.android)}
              data-name="安卓下载"
              aria-label="安卓下载"
              href={store.downloadUrl.android}
              target="_blank"
              onClick={event =>
                handleDownloadLinkClick(event, store.downloadUrl.android, () => {
                  $$tracker.clickDownloadAndroid('首页');
                })
              }
            />
            <Link
              className={cx(styles.publicBetaButton, styles.ios)}
              data-name="苹果下载"
              aria-label="苹果下载"
              href={store.downloadUrl.apple}
              target="_blank"
              onClick={event =>
                handleDownloadLinkClick(event, store.downloadUrl.apple, () => {
                  $$tracker.clickDownloadIOS('首页');
                })
              }
            />
          </div>
          <div className={cx(styles.platformColumn, styles.platformColumnSecondary)}>
            <button
              type="button"
              className={cx(styles.publicBetaButton, styles.harmony)}
              data-name="鸿蒙下载"
              aria-label="鸿蒙下载"
              onClick={() => {
                $$tracker.clickHongmengDown('首页');
                onOpenHarmonyDownloadModal();
              }}
            />
            <Link
              className={cx(styles.publicBetaButton, styles.pcDownload)}
              data-name="PC下载"
              aria-label="电脑端下载"
              href={store.downloadUrl.pc}
              target="_blank"
              onClick={event =>
                handleDownloadLinkClick(event, store.downloadUrl.pc, () => {
                  $$tracker.clickDownloadPC('首页');
                })
              }
            />
          </div>
          <Link
            className={styles.publicBetaRecharge}
            data-name="官方充值"
            aria-label="官方充值，赠元宝"
            href={store.downloadUrl.charge}
            target="_blank"
            onClick={event =>
              handleDownloadLinkClick(
                event,
                store.downloadUrl.charge,
                () => {
                  $$tracker.clickGoRecharge();
                },
                RECHARGE_UNAVAILABLE_MESSAGE
              )
            }
          >
            <span className={styles.rechargeBonus} aria-hidden="true" />
          </Link>
        </div>
      );
    },
    [store.downloadUrl]
  );

  return (
    <div className={styles.mainKv} style={{ backgroundImage: `url(${store.kvInfo.kv})` }}>
      {store.kvInfo.kv_video && <video src={store.kvInfo.kv_video} autoPlay muted loop />}
      {store.kvInfo.template !== 'mid' && (
        <div className={cx(styles.content, styles.noCenter)}>
          <div className={styles.contentBox} data-name="左版本">
            {store.kvInfo.template === 'left' && (
              <React.Fragment>
                {/* <div className={styles.logo} /> */}
                {/* <div className={styles.slogan} /> */}
                {store.kvInfo.slogan && <img className={styles.slogan} src={store.kvInfo.slogan} alt="" />}
                <div className={styles.indexComponents}>
                  <div className={styles.appointment}>{store.stage === 'appointment' ? appointment : download}</div>
                </div>
              </React.Fragment>
            )}
          </div>
          <div className={styles.contentBox} data-name="右版本">
            {store.kvInfo.template === 'right' && (
              <React.Fragment>
                {/* <div className={styles.logo} /> */}
                {/* <div className={styles.slogan} /> */}
                {store.kvInfo.slogan && <img className={styles.slogan} src={store.kvInfo.slogan} alt="" />}
                <div className={styles.indexComponents}>
                  <div className={styles.appointment}>{store.stage === 'appointment' ? appointment : download}</div>
                </div>
              </React.Fragment>
            )}
          </div>

          {/* <div className={styles.iconDown} /> */}
        </div>
      )}
      {store.kvInfo.template === 'mid' && (
        <div className={styles.content} data-name="居中版本">
          {/* <div className={styles.logo} /> */}
          {/* <div className={styles.slogan} /> */}
          {store.kvInfo.slogan && <img className={styles.slogan} src={store.kvInfo.slogan} alt="" />}
          <div className={styles.indexComponents}>
            <div className={styles.appointment}>{store.stage === 'appointment' ? appointment : download}</div>
          </div>
        </div>
      )}
      {store.kvInfo.video && (
        <div className={styles.playBox} onClick={() => store.openVideo()}>
          <img src={store.kvInfo.play_bg_img} alt="" />
          <Link className={styles.play} />
        </div>
      )}
      <div className={styles.iconDown} />

      <div className={styles.age}>
        <AgeAppropriateTips gameName={'剑侠世界4'} className={styles.ageTips} />
      </div>
    </div>
  );
};

export default wrapStore(MainKv, MainKvStore);
